<template>
  <div>
    <!-- Banner y título -->
    <div class="Linea1"></div>
    <div class="Linea2"></div>
    <div class="container mt-5">
      <h1 class="text-center mb-4">Traslados Disponibles</h1>

      <!-- Mostrar el origen y destino seleccionados -->
      <div class="text-bold mb-4">
        <p><strong>Origen:</strong> {{ nombreOrigen }}</p>
        <p><strong>Destino:</strong> {{ nombreDestino }}</p>
      </div>

      <!-- Mensaje si no hay tarifas disponibles -->
      <div v-if="tarifas.length === 0 && !error" class="alert alert-warning text-center">
        No hay tarifas disponibles para esta ruta.
      </div>

      <!-- Mostrar error -->
      <div v-if="error" class="alert alert-danger text-center">
        {{ error }}
      </div>

      <!-- Lista de tarifas -->
      <div v-if="tarifas.length > 0">
        <div class="card mb-3" v-for="(tarifa, index) in tarifas" :key="index">
          <div class="row g-0">
            <div class="col-md-3 d-flex align-items-center justify-content-center">
              <img
                src="@/assets/LogoCI.jpg"
                class="img-fluid rounded-circle"
                alt="Bus Logo"
              />
            </div>
            <div class="col-md-9">
              <div class="card-body">
                <h5 class="card-title text-uno">
                  Horario: {{ tarifa.Horario }}
                </h5>
                <p class="card-text text-dos">
                  <strong>Origen:</strong> {{ tarifa.Ubicacion_origen }} <br />
                  <strong>Destino:</strong> {{ tarifa.Ubicacion_destino }}
                </p>
                <p class="card-text text-tres">
                  <strong>Costo:</strong> ${{ tarifa.Costo }}
                </p>
                <button class="btn btn-primary" @click="abrirReservacion(tarifa)">Continuar</button>

              </div>
            </div>
          </div>
        </div>
      </div>
    
      <div class="accordion mt-5" id="accordionExample">
  <!-- Acordeón de Reservación -->
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingReservacion">
      <button
        class="accordion-button"
        :class="{ collapsed: !mostrarReservacion }"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapseReservacion"
        aria-expanded="mostrarReservacion"
        aria-controls="collapseReservacion"
        >
        Datos Para solicitar la Reservación
      </button>
    </h2>
    <div
      id="collapseReservacion"
      class="accordion-collapse collapse"
      :class="{ show: mostrarReservacion }"
      aria-labelledby="headingReservacion"
      data-bs-parent="#accordionExample"
    >
      <div class="accordion-body">
        <div v-if="tarifaSeleccionada && tarifaSeleccionada.Horario">
            <p><strong>Traslado:</strong> {{ tarifaSeleccionada.Horario }}</p>
            <p><strong>Origen:</strong> {{ tarifaSeleccionada.Ubicacion_origen }}</p>
            <p><strong>Destino:</strong> {{ tarifaSeleccionada.Ubicacion_destino }}</p>
        </div>
        <div v-else>
            <p>No se ha seleccionado una tarifa. Por favor selecciona una tarifa.</p>
        </div>
        <form @submit.prevent="irAcordeonCliente">
       
  <div class="mb-3">
  <label for="fecha" class="form-label">Fecha de reservación</label>
  <input
    type="date"
    class="form-control"
    v-model="formData.fecha"
    :min="fechaMinima"
    @input="validarFecha"
    required
  />
</div>

          <div class="row mb-3">
            <div class="col-md-6">
  <label for="adultos" class="form-label">Adultos</label>
  <input
    type="number"
    class="form-control"
    v-model="formData.adultos"
    min="2"
    @blur="validarAdultos"
    required
  />
</div>

            <div class="col-md-6">
              <label for="ninos" class="form-label">Niños (mayores de 6 años)</label>
              <input
                type="number"
                class="form-control"
                v-model="formData.ninos"
                min="0"
              />
            </div>
          </div>
          <div class="mb-3">
            <label for="totalPasajeros" class="form-label">Total de pasajeros</label>
            <input
              type="number"
              class="form-control"
              :value="totalPasajeros"
              readonly
            />
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Acordeón de Cliente -->
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingCliente">
      <button
        class="accordion-button"
        :class="{ collapsed: !mostrarRegistroCliente }"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapseCliente"
        aria-expanded="mostrarRegistroCliente"
        aria-controls="collapseCliente"
      >
        Registro de Cliente
      </button>
    </h2>
    <div
      id="collapseCliente"
      class="accordion-collapse collapse"
      :class="{ show: mostrarRegistroCliente }"
      aria-labelledby="headingCliente"
      data-bs-parent="#accordionExample"
    >
      <div class="accordion-body">
        <form @submit.prevent="guardarReservacionYCliente">
          <div class="mb-3">
            <label for="nombreCliente" class="form-label">Nombre del Cliente</label>
            <input
              type="text"
              class="form-control"
              v-model="clienteData.nombreCliente"
              required
            />
          </div>
          <div class="mb-3">
            <label for="correoCliente" class="form-label">Correo Electrónico</label>
            <input
              type="email"
              class="form-control"
              v-model="clienteData.correoCliente"
              required
            />
          </div>
          <div class="mb-3">
            <label for="numeroCliente" class="form-label">Número de Teléfono</label>
  <input
    type="text"
    class="form-control"
    v-model="clienteData.numeroCliente"
    @input="validarNumeroTelefono"
    maxlength="20"
    required
  />
  <div v-if="!esNumeroValido" class="text-danger">
    El número debe tener al menos 10 dígitos.
  </div>
</div>
          <div class="text-center">
            <button type="submit" class="btn btn-primary">Guardar y Continuar</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
  name: "TarifasDisponibles",
  data() {
    return {
    mostrarReservacion: false, // Inicialmente oculto
    mostrarRegistroCliente: false, // También oculto

    formData: {
      fecha: "",
      adultos: 2,
      ninos: 0,
    },


    clienteData: {
      nombreCliente: "",
      correoCliente: "",
      numeroCliente: "",
    },
    
    esNumeroValido: true, 

      // Fecha mínima para reservación
      fechaMinima: new Date().toISOString().split('T')[0],  // Fecha actual en formato YYYY-MM-DD

      // Parámetros y datos de ubicaciones
      origen: this.$route.query.origen || "", 
      destino: this.$route.query.destino || "", 
      nombreOrigen: "", 
      nombreDestino: "", 

      // Listado de tarifas y datos seleccionados
      tarifas: [], 
      tarifaSeleccionada: {}, 

      // Control de errores
      idRegistro: null, 
      error: null,
    };
  },
  mounted() {
    // Establece la fecha mínima al día actual en formato yyyy-MM-dd
    const hoy = new Date();
    const anio = hoy.getFullYear();
    const mes = (hoy.getMonth() + 1).toString().padStart(2, "0");
    const dia = hoy.getDate().toString().padStart(2, "0");
    this.fechaMinima = `${anio}-${mes}-${dia}`;
  },
  computed: {
    totalPasajeros() {
      const adultos = Number(this.formData.adultos) || 0;
      const ninos = Number(this.formData.ninos) || 0;
      return adultos + ninos;
    },
  },
  created() {
    this.obtenerUbicaciones();
    this.obtenerTarifas();
  },
  
  methods: {

    validarFecha() {
      const fechaActual = new Date(this.fechaMinima); // Convertir fecha mínima a objeto Date
      const fechaIngresada = new Date(this.formData.fecha); // Convertir fecha ingresada a objeto Date

      if (fechaIngresada < fechaActual) {
        // Limpiar el campo si la fecha es inválida
        this.formData.fecha = '';
        
        // Mostrar SweetAlert
        Swal.fire({
          icon: 'error',
          title: 'Fecha inválida',
          text: 'No puedes seleccionar una fecha anterior a la actual.',
          confirmButtonText: 'Entendido',
        });
      }
    },

    validarAdultos() {
      if (this.formData.adultos < 2) {
        this.formData.adultos = 2; // Restablecer al mínimo permitido
        Swal.fire({
          icon: 'error',
          title: 'Valor inválido',
          text: 'El número de adultos no puede ser menor a 2.',
          confirmButtonText: 'Entendido',
        });
      }
    },

    validarNumeroTelefono() {
  // Filtrar solo números
  const soloNumeros = this.clienteData.numeroCliente.replace(/\D/g, "");

  // Limitar a 20 caracteres como máximo
  if (soloNumeros.length > 20) {
    this.clienteData.numeroCliente = soloNumeros.slice(0, 20);
  } else {
    this.clienteData.numeroCliente = soloNumeros;
  }

  // Validar longitud mínima
  if (soloNumeros.length < 10) {
    this.esNumeroValido = false; // Marcamos como inválido
  } else {
    this.esNumeroValido = true; // Marcamos como válido
  }
},

    
    async obtenerUbicaciones() {
  try {
    // Verificar si `origen` y `destino` están definidos
    if (!this.origen || !this.destino) {
      console.error("Origen o destino no están definidos en los parámetros.");
      this.nombreOrigen = "No definido";
      this.nombreDestino = "No definido";
      return;
    }

    // Realizar la solicitud al backend
    const response = await fetch( this.$backendUrl + "obtenerUbicaciones.php")
    ;
    const data = await response.json();

    if (data.success) {
      const ubicaciones = data.ubicaciones;

      // Depuración
      console.log("Datos de ubicaciones recibidos:", ubicaciones);
      console.log("Parámetros de origen:", this.origen, "destino:", this.destino);

      // Buscar las ubicaciones correspondientes
      const origenObj = ubicaciones.find(
        (ubicacion) => ubicacion.Id_ubicacion == this.origen
      );
      const destinoObj = ubicaciones.find(
        (ubicacion) => ubicacion.Id_ubicacion == this.destino
      );

      // Asignar nombres o valores predeterminados
      this.nombreOrigen = origenObj ? origenObj.Nombre : "No definido";
      this.nombreDestino = destinoObj ? destinoObj.Nombre : "No definido";
    } else {
      console.error("Error al cargar ubicaciones desde el backend:", data.message);
      this.nombreOrigen = "No definido";
      this.nombreDestino = "No definido";
    }
  } catch (error) {
    console.error("Error en la solicitud al backend:", error);
    this.nombreOrigen = "Error al cargar";
    this.nombreDestino = "Error al cargar";
  }
},

    async obtenerTarifas() {
      try {
        const response = await fetch(
          this.$backendUrl+"traslados.php",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              origen: this.origen,
              destino: this.destino,
            }),
          }
        );

        const data = await response.json();

        if (data.success) {
          this.tarifas = data.tarifas;
          this.error = null;
        } else {
          this.tarifas = [];
          this.error = data.message || "Error desconocido del servidor.";
        }
      } catch (error) {
        this.tarifas = [];
        this.error = "Error al conectar con el servidor.";
      }
    },

      abrirAccordionReservacion(tarifa) {
      this.tarifaSeleccionada = tarifa; 
      this.mostrarReservacion = true;
    },

    cerrarReservacion() {
  this.mostrarReservacion = false;
},


  irAcordeonCliente() {
    if (!this.formData.fecha || this.formData.adultos < 1) {
      alert("Por favor, completa todos los campos obligatorios.");
      return;
    }
    this.mostrarReservacion = false; // Cierra el acordeón de reservación
    this.mostrarRegistroCliente = true; // Abre el acordeón de cliente
  },


   abrirReservacion(tarifa) {
    this.tarifaSeleccionada = tarifa; 
    this.mostrarReservacion = true; 
  },

  async guardarReservacionYCliente() {

    const ninos = Number(this.formData.ninos); // Asegura que sea un número
  if (isNaN(ninos) || ninos < 0) {
    alert("El campo 'niños' debe contener un número válido (puede ser 0).");
    return;
  }



  // Construir los datos
  const data = {    
    reservacion: {
      FechaReservacion: this.formData.fecha || "", 
      HoraReservacion: this.tarifaSeleccionada.Horario || "", 
      TotalPasajeros: this.totalPasajeros,
      Adultos: this.formData.adultos,
      Ninos: ninos,
      Origen: this.origen,
      Destino: this.destino,
    },
    cliente: {
      NombreCliente: this.clienteData.nombreCliente.trim(),
      CorreoCliente: this.clienteData.correoCliente.trim(),
      NumeroCliente: this.clienteData.numeroCliente.trim(),
    },
  };



  // Verificar si los datos están completos
  if (
    !data.reservacion.FechaReservacion ||
    !data.reservacion.HoraReservacion ||
    !data.reservacion.Origen ||
    !data.reservacion.Destino ||
    !data.cliente.NombreCliente ||
    !data.cliente.CorreoCliente ||
    !data.cliente.NumeroCliente
  ) {
    alert("Por favor, completa todos los campos obligatorios.");
    return;
  }

  try {
    const response = await fetch(
      this.$backendUrl+"guardarReservacionCliente.php",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }
    );

    const result = await response.json();
    console.log("Respuesta del servidor:", result);

    if (result.success) {
  Swal.fire({
    icon: 'success',
    title: '¡Datos guardados correctamente!',
    text: `Folio: ${result.folio}`,
    confirmButtonText: 'Continuar'
  }).then(() => {

    // Redirigir al usuario después de cerrar la alerta
    this.$router.push({ path: "/confirmacion", query: { folio: result.folio } });
  });
} else {
  Swal.fire({
    icon: 'error',
    title: 'Error',
    text: result.message || "Error al guardar los datos.",
    confirmButtonText: 'Intentar nuevamente'
  });
}

  } catch (error) {
    alert("Error al conectar con el servidor.");
    console.error(error);
  }
}


  },
};
</script>


<style scoped>

/* Contenedor principal */
.container {
  background-image: url('/src/assets/fondo2.jpg'); 
  background-size: cover;
  max-width: 1000px;
  margin: 40px auto;
}

h1 {
  color: rgb(255, 255, 255);
  text-align: center;
  font-family:  'Arial', sans-serif;
  font-size: px;
  text-transform: uppercase;
  margin-top: -30px; 
  
}
  
.text-bold {
    color: rgb(245, 226, 197);
    font-weight: bold;
    margin-top: -20px; 
  text-align: center;

}

/* Tamaño de las tarjetas */
.card {
  width: 90%; 
  margin: 0px auto; 
  padding: 10px; 
  border-radius: 10px; 
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); 
}

/* Título */
.card .card-title {
  font-size: 20px; 
  font-weight: bold;
  font-family: 'Arial', sans-serif; 
  margin-bottom: 5px;
}

/* Texto de la tarjeta */
.card .card-text {
  font-size: 16px; 
  line-height: 1.5; 
  font-family: 'Arial', sans-serif; 
  color: #555555; 
  margin-bottom: 10px;
}

/* Imagen circular */
.card img {
  width: 80px; 
  height: 80px;
  border-radius: 120%; 
  margin: 0px auto; 
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.1); 
  object-fit: cover; 
}

.text-uno{
  color: #007bff !important; 
  font-size: 16px; 
}

.text-dos {
  color: #6c757d;
  font-size: 14px; 
}

/* Costo */
.card .text-tres {
  font-size: 14px;
  font-weight: bold;
  color: #ea1a1a !important ;
}

/* Estilo para el botón "Reservar" */
.btn.btn-primary {
  background-color: #007bff; 
  color: #fff; 
  font-size: 14px; 
  font-weight: bold; 
  padding: 5px 20px; 
  border: none; 
  border-radius: 5px; 
  cursor: pointer; 
  transition: background-color 0.3s ease, transform 0.2s ease; 
  margin-right: 10px; 
}

/* Estilo para el botón "Cerrar" */
.btn.btn-secondary {
  background-color: #9ca7b4; 
  color: #fff; 
  font-size: 14px; 
  font-weight: bold; 
  padding: 5px 20px; 
  border: none; 
  border-radius: 5px; 
  cursor: pointer; 
  transition: background-color 0.3s ease, transform 0.2s ease; 
}


/* Cambio de color al pasar el mouse */
.btn.btn-primary:hover {
  background-color: #29b39c; 
}


/* Estilos para el acordeón */
.accordion {
  border: 3px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background-color: #f9f9f9;
}

.accordion-item {
  border: none;
  border-radius: 8px;
}

.accordion-header .accordion-button {
  background-color: #29b39c!important; 
  color: #fff;
  border: none;
  font-size: 1.1rem;
  font-weight: bold;
  border-radius: 8px;
  padding: 12px;
  transition: background-color 0.3s ease;
}

.accordion-header .accordion-button:not(.collapsed) {
  background-color: #0056b3; 
}

.accordion-header .accordion-button:hover {
  background-color: #0056b3; 
}

.accordion-body {
  background-color: #fff;
  border-top: 1px solid #ddd;
  border-radius: 0 0 8px 8px;
  padding: 20px;
  font-size: 0.95rem;
  color: #007bff;
}

/* Estilos para las etiquetas y formularios */
.form-label {
  font-weight: bold;
  color: #555;
}

.form-control {
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 8px 12px;
  transition: border-color 0.3s ease;
}

/* Botones */
.btn-primary {
  background-color: #007bff;
  border-color: #007bff;
  color: #fff;
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 1rem;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
}

.btn-primary:hover {
  background-color: #0056b3;
  box-shadow: 0 4px 8px rgba(0, 123, 255, 0.3);
}

.btn-secondary {
  background-color: #6c757d;
  border-color: #6c757d;
  color: #fff;
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 1rem;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
}

.btn-secondary:hover {
  background-color: #5a6268;
  box-shadow: 0 4px 8px rgba(108, 117, 125, 0.3);
}

/* Estilo adicional para botones centrados */
.text-center button {
  margin: 0 8px;
}

/* Sombra en hover para inputs */
input.form-control:hover {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

</style>

  